import "../Style.css"; import "../Responsive.css";
import React, { useState } from "react";
import { connectToStore } from "../data/store";
import {
    SettingsMenuList,
} from "../core/Constants";
import {
    Box,
    Stack,
    Typography,
    List,
    ListItem,
    ListItemText,
    ListItemButton,
    Grid
} from "@mui/material";
import { Link } from "react-router-dom";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import {
    VendorPage,
} from "../core/PageConstants";

const InventoryMenuItems = ({ selectedMenu }) => {
    const [localSettings, setLocalSettings] = useState(connectToStore());
    const [productStockReportAvailable, setProductStockReportAvailable] = useState(true);
    return (
        <Grid xs={12} md={3}>
            <Box className="left-menu">
                <Stack className="left-menu-inner">
                    <Typography
                        level="h3"
                        component="h3"
                        fontWeight="600"
                        fontSize="2rem"
                        className="h3"
                    >
                        Inventory
                    </Typography>
                    <nav className="font-size-15">
                        <List>

                            <Link to={VendorPage.Path}>
                                <ListItem disablePadding>
                                    <ListItemButton
                                        component="a"
                                        className={
                                            selectedMenu == SettingsMenuList.InventorySettings.VendorSetup
                                                ? "active"
                                                : null
                                        }
                                    >
                                        <ListItemText
                                            primary={SettingsMenuList.InventorySettings.VendorSetup}
                                        />
                                        <NavigateNextIcon />
                                    </ListItemButton>
                                </ListItem>
                            </Link>
                        </List>
                    </nav>
                </Stack>
            </Box >
        </Grid>
    );
};

export default InventoryMenuItems;
